import Utils from "../../../../../../../../../core/services/utils/utils";

/**
 * Parses the CSV / correction UI target (`isSerialized` column).
 * @param {*} value
 * @returns {boolean|undefined}
 */
export const parseImportIsSerialized = (value) => {
    if (value === true || value === false) {
        return value;
    }
    return Utils.tryConvertStringToBoolean(value);
};

/**
 * Normalizes serializability from key-info (`isSerializable`) or toggle response (`isSerialized`).
 * @param {*} value
 * @returns {boolean|undefined}
 */
export const toSerializabilityBoolean = (value) => {
    if (value === true || value === false) {
        return value;
    }
    if (value == null) {
        return undefined;
    }
    return Utils.tryConvertStringToBoolean(String(value));
};

/**
 * Reads current serializability from `getProductKeyInformation` payload.
 * @param {*} keyInfoData
 * @returns {boolean}
 */
export const getCurrentSerializableFromKeyInfo = (keyInfoData) => {
    return toSerializabilityBoolean(keyInfoData?.isSerializable) ?? false;
};

/**
 * Reads resulting serializability from `toggleProductBeingSerialized` payload.
 * @param {*} toggleData
 * @returns {boolean|undefined}
 */
export const getResultingIsSerializedFromToggle = (toggleData) => {
    return toSerializabilityBoolean(toggleData?.isSerialized);
};
